import humps from 'lodash-humps-ts';
import { authAxios } from '@components/Auth';
import { BillingItemWithPrice } from '@models/BillingItemWithPrice';
import { API_V1_BASE } from '@config';

export type GetAllBillingItemParams = {
  benefitLimitId?: number;
  businessPartnerId?: number;
};

export class BillingItemApi {
  static getAll = async ({ benefitLimitId, businessPartnerId }: GetAllBillingItemParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/billing_items`, {
        params: {
          benefit_limit_id: benefitLimitId,
          business_partner_id: businessPartnerId,
        },
      })
      .then((response) => humps(response.data) as BillingItemWithPrice[]);
  };
}
